// @ts-nocheck
import React, { useEffect, useState } from "react";
import AlertMessage from "../Alias/AlertMessage";
import "../index.css";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import axios from "axios";
import { useBody } from "./state/BodyContext";
import localStorageManagement from "../Security/LocalStorageManagement";
import { URL_API_SIA } from "../Contantes/Constantes";
import { useAuth } from "../Auth/State/AuthContext";
import Grid from "@mui/material/Grid";
import { adaptV4Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { createTheme, ThemeProvider, StyledEngineProvider, styled } from '@mui/material/styles';
import SinapThemev2 from "../styles/SinapThemev2";
import BeneficiosCuentaInstitucional from "./BeneficiosCuentaInstitucional";
import { logOut } from "./logOut";
import { logIn } from "./logIn";
import Typography from "@mui/material/Typography";
import ModalCargando from "../Componentes/ModalCargando";
import CircularProgress from "@mui/material/CircularProgress";
import SignalWifiConnectedNoInternet4Icon from "@mui/icons-material/SignalWifiConnectedNoInternet4";
import Subtitulo from "./Subtitulo";
import Banner from "./Banner";
import CardContainer from "./CardContainer";
import NoticiasHome from "./NoticiasHome";

export const themeCardSizes = createTheme(
    adaptV4Theme({
        card: {
            height: "130px",
            width: "342px",
        },
        cardHover: {
            heightHover: "240px",
        },
        miniCard: {
            miniHeight: "90px",
            miniWidth: "290px",
        },
        grid: {
            miniGridHeight: "160px",
        },
    })
);
export const ExpandAvatar = styled("div")(({ theme }) => ({
    "&:hover": {
        transform: `scale(1.1,1.1)`,
        transition: `transform 150ms`,
    },
    cursor: "pointer",
}));

export const PaddingLogo = styled("div")(({ theme }) => ({
    paddingLeft: "5px",
}));

export const PaddingDiv = styled("div")(({ theme }) => ({
    // padding: 10,
}));

const ResponsiveDiv = styled("div")(({ theme }) => ({
    position: "absolute",
    marginTop: "10%",
    top: "20%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    [theme.breakpoints.down("lg")]: {
        top: "50%",
        width: "80%",
        height: "80%",
    },
}));

const useStyles = makeStyles((theme) => ({
    containerButtons: {
        marginBottom: 40,
        //clase de los botones
        "& .MuiButton-text": {
            padding: "8px 16px 8px 16px ",
            color: "black",
            textTransform: "none",
            fontSize: "30px",
            borderRadius: "25% / 60%",
            "&:hover": {
                color: "white",
                backgroundColor: "#77787c",
                transition: ".5s ease",
            },
        },
    },
    containerButtonsResponsive: {
        marginBottom: 40,
        backgroundColor: "#d9d9d9",
        borderRadius: "6px",
        paddingLeft: 0,
        paddingRight: 0,
        width: "107.7%",
        marginLeft: "-14px",
        "& .MuiButton-text": {
            padding: "4px 0px 4px 0px ",
            color: "black",
            textTransform: "none",
            fontSize: "120%",
        },
    },
}));

export default function Home({ error }) {
    const [alert, setAlert] = React.useState({
        status: "error",
        message: "Hubo un error al cargar la página (Codigo de error: 00018)",
    });
    const [checked, setChecked] = useState(false);
    const { user, isLogedIn } = useAuth();
    const [checkedSubTitle, setCheckedSubTitle] = useState(false);
    const [checkedContent, setCheckedContent] = useState(false);
    const [apps, setApps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [value, setValue] = React.useState(0);

    const axiosInstance = setupInterceptorsTo(
        axios.create({
            headers: {
                "Content-Type": "application/json",
            },
        })
    );
    const { setMessage, notices } = useBody();
    const classes = useStyles();
    const matches = useMediaQuery("(min-width:900px)");
    // Sistemas = Aplicaciones de la facultad sin miedo al exito
    const fetchSistemasPrivados = (url) => {
        axiosInstance({
            method: "GET",
            url: url,
        })
            .then((response) => {
                let allowedSystems = [];
                allowedSystems = response.data.data;
                const allowedSystemsSorted = sortSystems(allowedSystems);
                setApps(allowedSystemsSorted);
                setLoading(false);
            })
            .catch((e) => {
                setMessage(
                    "Hubo un error al traer los sistemas de la facultad codigo de error : 00020"
                );
                setLoading(false);
            });
    };
    const fetchSistemasPublicos = async (url) => {
        await axios({
            method: "GET",
            url: url,
        })
            .then((response) => {
                let allowedSystems = [];
                allowedSystems = response.data.data;
                const allowedSystemsSorted = sortSystems(allowedSystems);
                setApps(allowedSystemsSorted);
                setLoading(false);
            })
            .catch((e) => {
                setMessage(
                    "Hubo un error al traer los sistemas de la facultad codigo de error : 00020"
                );
                setLoading(false);
            });
    };

    const sortSystems = (systems) => {
        const userInfo = localStorageManagement.getUserInfo();

        systems.map((system) => {
            if (userInfo[system.title]) system.views = userInfo[system.title];
            else system.views = 0;
            return system;
        });

        return systems
            .sort((a, b) => {
                return a.views - b.views;
            })
            .reverse();
    };

    const handleChange = () => {
        setChecked((prev) => !prev);
    };

    const handleChangeSubTitle = () => {
        setCheckedSubTitle((prev) => !prev);
    };

    const handleChangeContent = () => {
        setCheckedContent((prev) => !prev);
    };

    const handleClickSecciones = (myLink) => {
        window.location.href = myLink;
    };

    useEffect(() => {
        let url = URL_API_SIA;

        if (error) setMessage(alert.message);

        if (!error)
            if (isLogedIn()) {
                url = url + "/cards/obtener/" + user.filiacion;
                fetchSistemasPrivados(url);
            } else {
                url = url + "/cards/publicas";
                fetchSistemasPublicos(url);
            }

        setTimeout(() => {
            handleChange();
        }, 500);
        setTimeout(() => {
            handleChangeSubTitle();
        }, 1000);
        setTimeout(() => {
            handleChangeContent();
        }, 1200);
    }, [user]);

    return (
        <>
            {error ? (
                <ResponsiveDiv>
                    <Grid
                        container
                        spacing={8}
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid item xs={12}>
                            <SignalWifiConnectedNoInternet4Icon
                                color="secondary"
                                sx={{ fontSize: 100 }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="h3"
                                color="primary"
                                sx={{ textAlign: "center" }}
                            >
                                {" "}
                                ¡Ocurrió un error con la red interna!
                            </Typography>
                            <br />
                            <Typography variant="h4" sx={{ textAlign: "center" }}>
                                {" "}
                                Espero unos minutos y refresque la página
                            </Typography>
                            <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                                {" "}
                                Si el error persiste, notifique el error a
                                soporte@frba.utn.edu.ar
                            </Typography>
                            <Typography
                                variant="subtitle2"
                                color="secondary"
                                sx={{ textAlign: "center" }}
                            >
                                {" "}
                                (Código de error: 00018)
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <CircularProgress color="primary" size={35}></CircularProgress>
                        </Grid>
                    </Grid>
                </ResponsiveDiv>
            ) : (
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={SinapThemev2}>
                        <div style={{margin: matches ? "-24px" : "0px"}}>
                            <Banner/>
                            <br/>
                            <CardContainer apps={apps} loading={loading}/>
                            <br/>
                            <BeneficiosCuentaInstitucional/>
                            <br/><br/>
                            <NoticiasHome notices={notices} loading={loading}/>
                        </div>
                    </ThemeProvider>
                </StyledEngineProvider>
            )}
            <br />
            <br />
        </>
    );
}
